export default __webpack_public_path__ + "static/media/CASH-OUT-HOVER.090482d6.png";